export const HOME = {
  emergentLink: "home-emergent-link",
  bookNowHero: "home-book-now-hero",
  bookNowNav: "nav-book-now",
  trackOrderNav: "nav-track-order",
  servicesSection: "home-services-section",
  gallerySection: "home-gallery-section",
  reviewsSection: "home-reviews-section",
  promoBanner: "home-promo-banner",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkGallery: "nav-link-gallery",
  linkTrack: "nav-link-track",
  linkBook: "nav-link-book",
  linkAdmin: "nav-link-admin",
  mobileToggle: "nav-mobile-toggle",
};

export const BOOK = {
  step1Service: "book-step1-service",
  step2Date: "book-step2-date",
  step3Photos: "book-step3-photos",
  step4Contact: "book-step4-contact",
  serviceOption: (s) => `book-service-${s}`,
  locationSelect: "book-location-select",
  dateInput: "book-date-input",
  timeInput: "book-time-input",
  photoUpload: "book-photo-upload",
  photoPreview: (i) => `book-photo-preview-${i}`,
  nameInput: "book-name-input",
  phoneInput: "book-phone-input",
  emailInput: "book-email-input",
  notesInput: "book-notes-input",
  nextBtn: "book-next-btn",
  backBtn: "book-back-btn",
  submitBtn: "book-submit-btn",
  successCode: "book-success-code",
};

export const TRACK = {
  codeInput: "track-code-input",
  phoneInput: "track-phone-input",
  lookupBtn: "track-lookup-btn",
  statusBadge: "track-status-badge",
  reviewLink: "track-review-link",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutBtn: "admin-logout-btn",
  navBookings: "admin-nav-bookings",
  navPromos: "admin-nav-promos",
  navReviews: "admin-nav-reviews",
  navContent: "admin-nav-content",
  navBusiness: "admin-nav-business",
  bookingRow: (id) => `admin-booking-row-${id}`,
  statusSelect: (id) => `admin-status-select-${id}`,
  depositInput: (id) => `admin-deposit-input-${id}`,
  saveBookingBtn: (id) => `admin-save-booking-${id}`,
  promoAddBtn: "admin-promo-add",
  promoTitle: "admin-promo-title",
  promoBody: "admin-promo-body",
  promoStart: "admin-promo-start",
  promoEnd: "admin-promo-end",
  promoSave: "admin-promo-save",
  reviewApproveBtn: (id) => `admin-review-approve-${id}`,
  reviewFeatureBtn: (id) => `admin-review-feature-${id}`,
  postAddBtn: "admin-post-add",
  postCaption: "admin-post-caption",
  postSave: "admin-post-save",
  postDay: "admin-post-day",
  businessSave: "admin-business-save",
};

export const PAY = {
  payDepositBtn: "pay-deposit-btn",
  paymentStatus: "payment-status",
};
